"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionLog = void 0;
class TransactionLog {
    constructor(contextId, referenceId, referenceType, userDisplayName, userId, deviceName, appName, appVersion, appBuildNo, appPlatform, appPlatformVersion, locationCoordinates) {
        this.contextId = contextId;
        this.referenceId = referenceId;
        this.referenceType = referenceType;
        this.userDisplayName = userDisplayName;
        this.userId = userId;
        this.deviceName = deviceName;
        this.appName = appName;
        this.appVersion = appVersion;
        this.appBuildNo = appBuildNo;
        this.appPlatform = appPlatform;
        this.appPlatformVersion = appPlatformVersion;
        this.locationCoordinates = locationCoordinates;
        this.identifier = undefined;
        this.creationDate = new Date();
        this.timeStamp = new Date();
        this.updateTimestamp = new Date();
        this.fieldName = undefined;
        this.newValue = null;
        this.oldValue = null;
        this.operation = undefined;
    }
    setCreate(newValue) {
        this.operation = OperationTypes.CREATE;
        this.newValue = newValue;
    }
    setUpdate(fieldName, oldValue, newValue) {
        this.operation = OperationTypes.UPDATE;
        this.fieldName = fieldName;
        this.oldValue = oldValue;
        this.newValue = newValue;
    }
    setDelete(fieldName, oldValue) {
        this.operation = OperationTypes.UPDATE;
        this.oldValue = oldValue;
        if (fieldName != null)
            this.fieldName = fieldName;
        this.newValue = null;
    }
    setDocumentDelete(oldValue) {
        this.operation = OperationTypes.DELETE;
        this.oldValue = oldValue;
        this.newValue = null;
    }
    setHitReport(gameRecord, associatedSamples, reportGuid, hitReportData) {
        this.operation = OperationTypes.HI_TIER_REPORT;
        this.newValue = {
            gameRecord,
            associatedSamples,
            reportGuid,
            hitReportData
        };
    }
    toString() {
        return JSON.stringify(this);
    }
}
exports.TransactionLog = TransactionLog;
var OperationTypes;
(function (OperationTypes) {
    OperationTypes["CREATE"] = "create";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["HI_TIER_REPORT"] = "HIT";
})(OperationTypes || (OperationTypes = {}));
